import React, { useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation.ts';
import ContactModal from './ContactModal.tsx';

const Cta: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation<HTMLDivElement>();
  const [isContactModalVisible, setContactModalVisible] = useState(false);

  return (
    <>
    <section id="cta" ref={ref} className="py-24">
      <div className={`container mx-auto px-6 scroll-animation ${isVisible ? 'visible' : ''}`}>
        <div className="bg-gray-100 dark:bg-gray-900/50 rounded-2xl overflow-hidden shadow-2xl shadow-orange-600/20 dark:shadow-2xl dark:shadow-[#FF4D00]/20 border border-gray-200 dark:border-gray-800/50">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            
            {/* Left Column: Value Proposition & Social Proof */}
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">Stop Losing Track of Your Equipment.</h2>
              <p className="text-gray-700 dark:text-gray-300 max-w-2xl mb-8">
                Get a personalized demo and see how Shield can reduce admin time by 60% and get you to 100% audit readiness.
              </p>
              
              <div className="bg-white dark:bg-black/20 p-6 rounded-lg border border-gray-200 dark:border-gray-700/50">
                  <blockquote className="text-gray-800 dark:text-gray-200 italic mb-4">
                    "Generating an audit trail used to take us weeks. Now, I can pull a complete logbook for any piece of equipment in seconds. Shield makes us 100% audit-ready."
                  </blockquote>
                  <div className="flex items-center">
                    <img src="https://picsum.photos/100/100?random=6" alt="Maria Garcia" className="h-12 w-12 rounded-full mr-4 border-2 border-orange-500/30"/>
                    <div>
                      <p className="font-semibold text-gray-900 dark:text-white">Maria Garcia</p>
                      <p className="text-sm text-gray-600 dark:text-gray-400">Compliance Officer</p>
                    </div>
                  </div>
              </div>
            </div>

            {/* Right Column: CTAs and Visual */}
            <div className="relative min-h-[400px] flex flex-col items-center justify-center p-8 md:p-12 bg-gray-800">
                <img 
                    src="https://picsum.photos/seed/cta-bg/800/600" 
                    alt="Equipment management dashboard"
                    className="absolute inset-0 w-full h-full object-cover opacity-20"
                />
                <div className="relative z-10 text-center flex flex-col items-center gap-4 w-full max-w-xs">
                    <button
                      onClick={() => setContactModalVisible(true)}
                      className="w-full bg-orange-600 text-white dark:bg-[#FF4D00] dark:text-black font-semibold px-8 py-4 rounded-lg hover:bg-orange-700 dark:hover:bg-white transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-orange-600/30 dark:shadow-2xl dark:shadow-[#FF4D00]/30"
                    >
                      Request a Demo
                    </button>
                    <button
                      onClick={() => setContactModalVisible(true)}
                      className="w-full bg-transparent text-white font-semibold px-8 py-4 rounded-lg hover:bg-white/10 transition-all duration-300 border border-white/30"
                    >
                      Contact Sales
                    </button>
                </div>
            </div>

          </div>
        </div>
      </div>
    </section>
    <ContactModal isVisible={isContactModalVisible} onClose={() => setContactModalVisible(false)} />
    </>
  );
};

export default Cta;